export default {
      id: "car-front-usage",
      viewBox: "0 0 50 35",
      url: __webpack_public_path__ + "img/icons.svg#car-front",
      toString: function () {
        return this.url;
      }
    }